<div class="dialogContainer">
  <div class="content">
    <div class="availableContainer">
      <h4>Available Columns</h4>
      <mat-selection-list #availableColumnList class="selectionList">
        @for (columnName of availableColumns; track columnName) {
          <mat-list-option [value]="columnName.code"
            [togglePosition]="'before'">
            {{ columnName.description }}
          </mat-list-option>
        }
      </mat-selection-list>
    </div>
    <div class="buttonContainer">
      <span class="verticalMiddle">
        <button matButton="text" class="inputButton"
          [disabled]="(availableColumnList.selectedOptions?.selected?.length || 0) === 0"
          (click)="addSelectedColumns(availableColumnList.selectedOptions.selected)">
          <span>
            <label class="buttonLabel">Add</label>
            <mat-icon class="size-16">arrow_forward</mat-icon>
          </span>
        </button>
        <button matButton="text" class="inputButton"
          [disabled]="(selectedColumnList.selectedOptions?.selected?.length || 0) === 0"
          (click)="removeSelectedColumns(selectedColumnList.selectedOptions.selected)">
          <span>
            <mat-icon class="size-16">arrow_back</mat-icon>
            <label class="buttonLabel">Remove</label>
          </span>
        </button>
      </span>
    </div>
    <div class="selectedContainer">
      <h4>Selected Columns</h4>
      <mat-selection-list #selectedColumnList class="selectionList" [multiple]="true">
        @for (columnName of selectedColumns; track columnName) {
          <mat-list-option [value]="columnName.code"
            [togglePosition]="'before'">
            {{ columnName.description }}
          </mat-list-option>
        }
      </mat-selection-list>
    </div>
    <div class="buttonContainer">
      <span class="verticalMiddle">
        <button matButton="text" class="inputButton"
          [disabled]="(selectedColumnList.selectedOptions?.selected?.length || 0) === 0 || !canMoveUp(selectedColumnList.selectedOptions.selected)"
          (click)="moveFieldsUp(selectedColumnList.selectedOptions.selected)">
          <span>
            <mat-icon class="size-16">expand_less</mat-icon>
            <label class="buttonLabel">Move Up</label>
          </span>
        </button>
        <button matButton="text" class="inputButton"
          [disabled]="(selectedColumnList.selectedOptions?.selected?.length || 0) === 0 || !canMoveDown(selectedColumnList.selectedOptions.selected)"
          (click)="moveFieldsDown(selectedColumnList.selectedOptions.selected)">
          <span>
            <mat-icon class="size-16">expand_more</mat-icon>
            <label class="buttonLabel">Move Down</label>
          </span>
        </button>
      </span>
    </div>
  </div>
  <div class="buttonRow">
    <span class="spacer"></span>
    <button matButton="elevated" class="dialogButton warn-button" (click)="cancel()">
      <span>
        <mat-icon class="size-16">cancel</mat-icon>
        <label class="buttonLabel">Cancel</label>
      </span>
    </button>
    <button matButton="elevated" class="dialogButton primary-button" [disabled]="(selectedColumns?.length || 0) === 0" (click)="save()">
      <span>
        <mat-icon class="size-16">save</mat-icon>
        <label class="buttonLabel">Save</label>
      </span>
    </button>
  </div>
</div>
